import { IGameInformationStateProps } from "../../v2/redux/reducers/GameInformation.reducer";
import { IActivityStateProps } from "./Activity/Common/Activity.reducers";
import { IAutoplaySettingsStateProps } from "./AutoplaySettings/Common/AutoplaySettings.reducers";
import { IDialogsStateProps } from "./Dialogs/Common/Dialogs.reducers";
import { IFooterStateProps } from "./Footer/Common/Footer.reducers";
import { IHeaderStateProps } from "./Header/Common/Header.reducers";
import { IKeypadStateProps } from "./Keypad/Common/Keypad.reducers";
import { IMenuStateProps } from "./Menu/Common/Menu.reducers";
import { IFreeSpinsState } from "../../v2/redux/reducers/FreeSpins.reducer";
import { IFreeRoundsState } from "../../v2/redux/reducers/FreeRounds.reducer";
import { IMoneyState } from "../../v2/redux/reducers/Money.reducer";

import "./Money";
import { IThemeStateProps } from "./Theme/Common/Theme.reducers";
import { ITickerDisplayStateProps } from "./TickerDisplay/Common/TickerDisplay.reducers";
import { DisplayMode as IDisplayModeStateProps } from "../../api/api";
import { View as IViewStateProps } from "../../api/api";
import { IPaytableState as IPaytableStateProps } from "../../api/api";

export * from "./Desktop";
export * from "./Mobile";

export interface IPlayUIStateProps {
  keypad: IKeypadStateProps;
  menu: IMenuStateProps;
  activity: IActivityStateProps;
  autoplay: IAutoplaySettingsStateProps;
  money: IMoneyState;
  dialogs: IDialogsStateProps;
  header: IHeaderStateProps;
  footer: IFooterStateProps;
  theme: IThemeStateProps;
  ticker: ITickerDisplayStateProps;
  gameInformation: IGameInformationStateProps;
  paytable: IPaytableStateProps;
  displayMode: IDisplayModeStateProps;
  view: IViewStateProps;
  freeRounds: IFreeRoundsState;
  freeSpins: IFreeSpinsState;
}
